import { Link } from 'react-router-dom'
import starLogo from '../../assets/images/star-tc.png'

export const Banner = () => {
    return (
        <div className="card overflow-hidden h-300p">
            <div className="card-body">
                <div className="row">
                    <div className="col-8 col-lg-7">
                        <h2 className="text-uppercase mb-5">
                            Think <span className="star-orange">creation</span>
                        </h2>
                        <p className="opacity-50 font-12 mb-5">Share your ideas</p>
                        <p className="font-lato font-12">
                            The idea can vary from developing an application and process
                            improvement to even something as simple as building a differential
                            proposal for potential clients.
                        </p>
                        <p className="font-lato font-12">
                            In other words, no matter how simple the idea is,{" "}
                            <span className="star-orange">
                                it must have the potential for a big impact.
                            </span>
                        </p>
                        <Link to="/post-idea"
                            className="btn btn-primary text-white text-uppercase rounded-10 font-lato font-10 py-15 waves-effect waves-float waves-light"
                        >
                            Post your ideas
                        </Link>
                    </div>
                    <div className="col-4 col-lg-5">
                        <img src={starLogo} alt="img" className="star-tc" />
                    </div>
                </div>
            </div>
        </div>

    )
}